module.exports = __webpack_public_path__ + "media/images/emblems/Coat_of_arms_of_Menziken-0431fec6209f5e6d53cbf1e33e0e7d82.svg";